export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-text">
                    Гібрид соняшника НС Х 8002 є новою розробкою, що спрямовується на кліматичні особливості України. Супер ранній гібрид соняшнику під Гранстар (технологія Sumo) є високоврожайним та стійким де стресових умов, невисоким і відноситься до помірно-інтенсивного типу. Потенційна врожайність гібрида соняшнику НС Х 8002 становить 58 ц/га.
                </p>
                <p className="card__description-title">
                    Характеристики
                </p>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Генетичний потенціал врожайності</td>
                        <td className="card__description__th-index">58 ц/га</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Група стиглості</td>
                        <td className="card__description__th-index">108-113 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Тип</td>
                        <td className="card__description__th-index">Помірно інтенсивний</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослини</td>
                        <td className="card__description__th-index">170-180 см</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність</td>
                        <td className="card__description__th-index">52-55%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Рекомендовані зони вирощування</td>
                        <td className="card__description__th-index">Степ, Лісостеп</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Стійкість до вовчка</td>
                        <td className="card__description__th-index">A-F</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Короткі дані
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Енергія початкового росту: 9/10</li>
                    <li className="card__description-numbering">Посухостійкість: 9/10</li>
                    <li className="card__description-numbering">Стійкість до вилягання: 8/10</li>
                    <li className="card__description-numbering">Толерантність до фомопсису: 9/10</li>
                    <li className="card__description-numbering">Толерантність до іржі: 10/10</li>
                </ol>
                <div className="card__description-title">Врожайність</div>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Київська область, Тетіївський район, 35 ц/га</li>
                    <li className="card__description-numbering">Черкаська область, Золотоніський район, 35 ц/га</li>
                    <li className="card__description-numbering">Вінницька область, Гайсинський район, 35 ц/га</li>
                    <li className="card__description-numbering">Кіровоградська область, Благовіщенський район, 38 ц/га</li>
                    <li className="card__description-numbering">Полтавська область, Хорольский район, 36 ц/га</li>
                </ol>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
